import { render, staticRenderFns } from "./SelectRemote.vue?vue&type=template&id=28cab1cf&scoped=true"
import script from "./SelectRemote.vue?vue&type=script&lang=js"
export * from "./SelectRemote.vue?vue&type=script&lang=js"
import style0 from "./SelectRemote.vue?vue&type=style&index=0&id=28cab1cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cab1cf",
  null
  
)

export default component.exports